// import external modules
import {combineReducers} from "redux"
// import internal(own) modules
import employee from "./employee";
import role from "./role";
import setting from "./setting";
import status from "./status";
import lobby from "./lobby";
import slider from "./slider";

const administrationReducer = combineReducers({
    employee,
    setting,
    role,
    status,
    lobby,
    slider,
});

export default administrationReducer;
